'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectScreenType = exports.matchesScreenType = exports.selectIsClient = exports.selectIsMobile = exports.selectMediaState = exports.setIsClient = exports.setMediaState = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _mediaQueries = require('constants/media-queries');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_MEDIA_STATE = 'classpass/device/SET_MEDIA_STATE'; /**
                                                           * Holds various device state, such as media size.
                                                           */

var SET_IS_CLIENT = 'classpass/device/SET_IS_CLIENT';

var setMediaState = exports.setMediaState = function setMediaState(mediaState) {
  return { type: SET_MEDIA_STATE, data: { key: 'media', val: mediaState } };
};
var setIsClient = exports.setIsClient = function setIsClient(isClient) {
  return { type: SET_IS_CLIENT, data: { key: 'isClient', val: isClient } };
};

var selectMediaState = exports.selectMediaState = function selectMediaState(state) {
  return state.device.media;
};
var selectIsMobile = exports.selectIsMobile = function selectIsMobile(state) {
  return !state.device.media.md;
};
var selectIsClient = exports.selectIsClient = function selectIsClient(state) {
  return state.device.isClient;
};

var matchesScreenType = exports.matchesScreenType = function matchesScreenType(screenType, state) {
  var mediaState = selectMediaState(state) || {};
  return !!mediaState[_mediaQueries.BREAKPOINT_BY_SCREEN_TYPE[screenType]];
};

var detectScreenType = exports.detectScreenType = function detectScreenType(state) {
  var matchesTablet = matchesScreenType(_mediaQueries.SCREEN_TYPES.tablet, state);
  var matchesDesktop = matchesScreenType(_mediaQueries.SCREEN_TYPES.desktop, state);
  return matchesDesktop && 'desktop' || matchesTablet && 'tablet' || 'phone';
};

var getInitialState = function getInitialState() {
  return {
    media: _mediaQueries.MEDIA_QUERY_DEFAULTS,
    isClient: false
  };
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_MEDIA_STATE:
    case SET_IS_CLIENT:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.data.key, action.data.val));
    default:
      return state;
  }
}